import React, { useState } from "react";
import { studentChangePassword } from "../../../../api/StudentDetails";
import { SweetAlertShow } from "../../../master/Master";

export default function PasswordUpdateModal({
    studentId,
    mobile,
    onClose,
}) {
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loading, setLoading] = useState(false);
    

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!newPassword) {
            SweetAlertShow("info", "Warning", "Please enter new password.");
            return;
        }

        if (newPassword.length < 6) {
            SweetAlertShow(
                "info",
                "Warning",
                "Password must be at least 6 characters."
            );
            return;
        }

        if (!confirmPassword) {
            SweetAlertShow(
                "info",
                "Warning",
                "Please enter confirm password."
            );
            return;
        }

        if (newPassword !== confirmPassword) {
            SweetAlertShow(
                "info",
                "Warning",
                "Password and confirm password do not match."
            );
            return;
        }

        setLoading(true);

        try {
            const response = await studentChangePassword({
                id: studentId,
                new_password: newPassword,
                confirm_password: confirmPassword,
            });

            if (response?.data?.status) {
                SweetAlertShow(
                    "success",
                    "Success",
                    response?.data?.message || "Password changed successfully."
                );

                setNewPassword("");
                setConfirmPassword("");

                onClose();
            } else {
                SweetAlertShow(
                    "error",
                    "Error",
                    response?.data?.message || "Password update failed."
                );
            }
        } catch (error) {
            SweetAlertShow(
                "error",
                "Error",
                error?.response?.data?.message ||
                error?.response?.message ||
                error?.message
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            className="modal d-block"
            style={{ background: "rgba(0,0,0,.5)" }}
            tabIndex={-1}
            onClick={onClose}
        >
            <div
                className="modal-dialog modal-dialog-centered"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="modal-content rounded-4 border-0 overflow-hidden">

                    <div className="modal-header border-0">
                        <div>
                            <h5 className="modal-title fw-bold d-flex align-items-center gap-2">
                                <i className="ri-lock-password-line text-primary"></i>
                                Update Password
                            </h5>

                            <small className="text-muted">
                                Update student login password
                            </small>
                        </div>

                        <button
                            type="button"
                            className="btn-close"
                            onClick={onClose}
                            disabled={loading}
                        />
                    </div>

                    <form onSubmit={handleSubmit}>

                        <div className="modal-body">

                            {/* Mobile Number */}
                            <div className="mb-3">
                                <label className="form-label fw-semibold">
                                    Mobile Number
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    value={mobile || "-"}
                                    readOnly
                                />
                            </div>

                            {/* New Password */}
                            <div className="mb-3">
                                <label className="form-label fw-semibold">
                                    New Password
                                </label>

                                <input
                                    type="password"
                                    className="form-control"
                                    placeholder="Enter new password"
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                    disabled={loading}
                                />
                            </div>

                            {/* Confirm Password */}
                            <div className="mb-3">
                                <label className="form-label fw-semibold">
                                    Confirm Password
                                </label>

                                <input
                                    type="password"
                                    className="form-control"
                                    placeholder="Confirm new password"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    disabled={loading}
                                />
                            </div>

                        </div>

                        <div className="modal-footer border-0">

                            <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={onClose}
                                disabled={loading}
                            >
                                <i className="ri-close-line me-1"></i>
                                Close
                            </button>

                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={loading}
                            >
                                {loading ? (
                                    <>
                                        <span
                                            className="spinner-border spinner-border-sm me-2"
                                            role="status"
                                        ></span>
                                        Updating...
                                    </>
                                ) : (
                                    <>
                                        <i className="ri-lock-password-line me-1"></i>
                                        Update Password
                                    </>
                                )}
                            </button>

                        </div>

                    </form>

                </div>
            </div>
        </div>
    );
}